import { createSlice } from '@reduxjs/toolkit';

import catalogs from 'domains/catalogs';
import subcatalogs from 'domains/subcatalogs';

import productsAdapter from './products.adapter';
import utils from './products.utils';

import type { PayloadAction } from '@reduxjs/toolkit';

const products = createSlice({
  name: 'products',
  initialState: productsAdapter.getInitialState({
    appliedFilter: 'All',
  }),
  reducers: {
    addMany: productsAdapter.addMany,
    setProductFilter(state, { payload }: PayloadAction<string>) {
      return { ...state, appliedFilter: payload };
    },
  },
  extraReducers(builder) {
    builder
      .addCase(catalogs.actions.getAllDeep.fulfilled, (state, { payload }) => {
        const templates = utils.flattenProductsFromCatalogs(payload);
        return productsAdapter.addMany(state, templates);
      })
      .addCase(subcatalogs.actions.fetchSubcatalogs.fulfilled, (state, { payload }) => {
        if (payload) {
          const result = utils.flattenProductsFromSubcatalogs(payload.subcatalogs);
          return productsAdapter.addMany(state, result);
        } else {
          return state;
        }
      });
  },
});

export default products;
